export default (target: number, min = -Infinity, max = Infinity) =>
  target < min ? min : target > max ? max : target;
